export const generateAttendanceCSV = (records, filename, stats) => {
  if (records.length === 0 && !stats) return alert('No records to download.');
  
  const csvRows = [];
  
  if (stats) {
    csvRows.push('"Attendance Summary"');
    csvRows.push(`"Scheduled","${stats.scheduled}"`);
    csvRows.push(`"Present","${stats.present}"`);
    csvRows.push(`"Late","${stats.late}"`);
    csvRows.push(`"Absent","${stats.absent}"`);
    csvRows.push(`"Leave","${stats.leave || 0}"`);
    csvRows.push(`"Make-up","${stats.makeup || 0}"`);
    csvRows.push('');
  }

  const headers = ['Date', 'Batch', 'Status', 'Note', 'Marked By'];
  csvRows.push(headers.join(','));
  
  records.forEach(r => {
    const row = [
      `"${r.Date}"`,
      `"${r.Batch}"`,
      `"${r.Status}"`,
      `"${r.Note}"`,
      `"${r.MarkedBy}"`
    ];
    csvRows.push(row.join(','));
  });

  if (records.length === 0) {
    csvRows.push('"No records marked this month."');
  }

  const blob = new Blob([csvRows.join('\n')], { type: 'text/csv' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `${filename}.csv`;
  a.click();
  window.URL.revokeObjectURL(url);
};

export const generateAttendancePDF = (records, filename, studentName, durationLabel, stats) => {
  if (records.length === 0 && !stats) return alert('No records to print.');
  
  const printWindow = window.open('', '_blank');
  const html = `
    <html>
      <head>
        <title>${filename}</title>
        <style>
          body { font-family: 'Arial', sans-serif; padding: 40px; color: #333; }
          h1 { color: #7b1d3a; margin-bottom: 5px; }
          p { color: #666; margin-top: 0; margin-bottom: 20px; }
          table { width: 100%; border-collapse: collapse; margin-top: 20px; }
          th, td { border: 1px solid #ddd; padding: 12px; text-align: left; font-size: 14px; }
          th { background-color: #f8f9fa; color: #444; }
          .badge { padding: 4px 8px; border-radius: 4px; font-weight: bold; font-size: 12px; }
          .PRESENT { background: #e8f5e9; color: #2e7d32; }
          .ABSENT { background: #ffebee; color: #c62828; }
          .LATE { background: #fff8e1; color: #f57f17; }
          .LEAVE { background: #eff6ff; color: #1d4ed8; }
          .MAKEUP, .MAKE-UP { background: #f5f3ff; color: #7c3aed; }
          .HOLIDAY { background: #f1f5f9; color: #64748b; }
          .RESCHEDULED { background: #e0f2fe; color: #0284c7; }
          .stats-grid { display: flex; gap: 14px; margin-bottom: 30px; flex-wrap: wrap; }
          .stat-box { border: 1px solid #ddd; padding: 12px 16px; border-radius: 8px; text-align: center; min-width: 80px; }
          .stat-val { font-size: 20px; font-weight: bold; margin-bottom: 4px; }
          .stat-lbl { font-size: 11px; color: #888; text-transform: uppercase; }
        </style>
      </head>
      <body>
        <h1>Attendance Report: ${studentName}</h1>
        <p>Duration: ${durationLabel}</p>
        
        ${stats ? `
          <div class="stats-grid">
            <div class="stat-box">
              <div class="stat-val" style="color: #666;">${stats.scheduled}</div>
              <div class="stat-lbl">Scheduled</div>
            </div>
            <div class="stat-box">
              <div class="stat-val" style="color: #10b981;">${stats.present}</div>
              <div class="stat-lbl">Present</div>
            </div>
            <div class="stat-box">
              <div class="stat-val" style="color: #f59e0b;">${stats.late}</div>
              <div class="stat-lbl">Late</div>
            </div>
            <div class="stat-box">
              <div class="stat-val" style="color: #ef4444;">${stats.absent}</div>
              <div class="stat-lbl">Absent</div>
            </div>
            <div class="stat-box">
              <div class="stat-val" style="color: #1d4ed8;">${stats.leave || 0}</div>
              <div class="stat-lbl">Leave</div>
            </div>
            <div class="stat-box">
              <div class="stat-val" style="color: #7c3aed;">${stats.makeup || 0}</div>
              <div class="stat-lbl">Make-up</div>
            </div>
          </div>
        ` : ''}

        ${records.length > 0 ? `
          <table>
            <thead>
              <tr>
                <th>Date</th>
                <th>Batch</th>
                <th>Status</th>
                <th>Note</th>
                <th>Marked By</th>
              </tr>
            </thead>
            <tbody>
              ${records.map(r => `
                <tr>
                  <td>${r.Date}</td>
                  <td>${r.Batch}</td>
                  <td><span class="badge ${r.Status?.toUpperCase()}">${r.Status}</span></td>
                  <td>${r.Note}</td>
                  <td>${r.MarkedBy}</td>
                </tr>
              `).join('')}
            </tbody>
          </table>
        ` : '<p><i>No records marked this month.</i></p>'}
        <script>
          window.onload = () => { window.print(); };
        </script>
      </body>
    </html>
  `;
  printWindow.document.write(html);
  printWindow.document.close();
};
